import {IToJson} from '@toolify/client/src/types/IToJson.js'

import {
  IGetJobRequestInterfaces,
} from '@toolify/server/src/controllers/JobController/validators/GetJob/types/IGetJobRequestInterfaces.js'

export function mapJobResponseInstance(job: IToJson<IGetJobRequestInterfaces['response']['job']>): IGetJobRequestInterfaces['response']['job'] {
  return {
    ...job,
    completedAt: job.completedAt ? new Date(job.completedAt) : null,
    failedAt: job.failedAt ? new Date(job.failedAt) : null,
  }
}
